import { render, staticRenderFns } from "./MasVendidos.vue?vue&type=template&id=743dd962&"
import script from "./MasVendidos.vue?vue&type=script&lang=js&"
export * from "./MasVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports